import { BALLS, CONFETTI, NO_CONFETTI } from "~/constants";
import demoBrandData from "~/mocks/demoBrandData";
import devBrandData from "~/mocks/devBrandData";
import devAllOrdersBrandData from "~/mocks/devAllOrdersBrandData";

export const localMockedBrands = [devBrandData(), demoBrandData(), devAllOrdersBrandData()];

export function getLocalMock(brandName) {
    return localMockedBrands.find((mb) => mb.brandName === brandName);
}

export function getLocalMockBrandData(brandName) {
    return getLocalMock(brandName)?.brandData;
}

export function isBrandLocalMock(brandName) {
    return !!getLocalMock(brandName);
}

export function getLocalMockBrandNames() {
    return localMockedBrands.map((mb) => mb.brandName);
}

export const SUCCESS_CONFETTI_OPTIONS = [NO_CONFETTI, CONFETTI, BALLS];
